module.exports = __webpack_public_path__ + "static/media/female-sleuth_1f575-fe0f-200d-2640-fe0f-2.89072dce.png";